import { styled } from "@mui/material/styles";
import { Avatar, Button, Card, Typography } from "@mui/material";

export const UserBookingTypePageContainer = styled("div")`
  width: 100%;
  max-width: 900px; /* On larger screens, content is constrained for readability */
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  margin: 0 auto;
  padding: 0 20px; /* Side padding for breathing room on large screens */

  @media (max-width: 600px) {
    max-width: 100%; /* Use full width on small devices */
    padding: 0;      /* Remove side padding so content spans the full width */
  }
`;




export const NotFoundContainer = styled("div")`
  width: 100%;
  display: flex;
  justify-content: center;
  height: 30%; /* Make sure the 404 container takes full height */
  align-items: center; /* Vertically center the content */
`;

export const BookingTypeCard = styled(Card)`
  display: flex;
  width: 95%;
  max-width: 1200px;
  min-width: 360px;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  margin-top: 40px;
  border-radius: 12px;
  box-shadow: 0px 6px 15px rgba(0, 0, 0, 0.1); /* Added shadow for card */
  background-color: ${({ theme }) => theme.palette.background.paper};
  color: ${({ theme }) => theme.palette.text.primary};
  background-image: none;
`;

export const UserInfo = styled("div")`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  padding-bottom: 30px;
`;

export const AvatarStyled = styled(Avatar)`
  width: 60px;
  height: 60px;
  font-size: 2rem;
  background-color: ${({ theme }) => theme.palette.primary.main}; /* A brand color for the avatar */
  color: ${({ theme }) => theme.palette.primary.contrastText};
`;

export const Username = styled(Typography)`
  font-weight: bold;
  font-size: 1.4rem;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const UserDesc = styled(Typography)`
  max-width: 400px;
  text-align: center;
  font-size: 1.1rem;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const NoBookingTypesMessage = styled(Typography)`
  font-size: 1.5rem;
  opacity: 0.7;
  margin-top: 20px;
  text-align: center;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const BookingTypesList = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%; 
`;

export const BookingTypeAccordion = styled("div")`
  width: 100%;
  margin-top: 20px;
`;
export const BookingTypeInfo = styled("div")`
  display: flex;
  flex: 1;
  gap: 10px;
  align-items: center;
`;

export const BookingTypeBox = styled("div")`
  display: flex; 
  width: 100%;
  background-color: ${({ theme }) => theme.palette.background.default};
  border: 1px solid ${({ theme }) => theme.palette.divider};
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 20px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  gap: 129px; 
`;

export const Circle = styled("div")`
  width:  ${(props) => props.width || "12px"};
  height:  ${(props) => props.height || "12px"};
  border-radius: 50%;
  background-color: ${(props) => props.color || "#007bff"};
`;

export const BookingTypeTitle = styled(Typography)` 
  font-size: 1rem;
  color: ${({ theme }) => theme.palette.text.primary};
  max-width: 250px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const BookingTypeDuration = styled(Typography)`
  font-size: 0.9rem;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const StyledButton = styled(Button)`
  padding: 10px 20px;
  background-color: ${({ theme }) => theme.palette.primary.main};
  color: ${({ theme }) => theme.palette.primary.contrastText};
  border-radius: 6px;
  font-weight: 600;
  text-transform: none;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: ${({ theme }) => theme.palette.primary.dark};
  }
`;

export const BookingTypeActions = styled("div")`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 15px;
`;

